import { Component, computed, inject, input } from '@angular/core'
import { AccountService, MIN_NEW_PASSWORD_LENGTH } from '@src/app/core/services/account.service.js'

@Component({
  selector: 'app-password-indicator',
  templateUrl: './password-indicator.component.html',
  styleUrls: ['./password-indicator.component.scss'],
  standalone: false,
})
export class PasswordIndicatorComponent {
  private accountService = inject(AccountService)

  readonly MIN_NEW_PASSWORD_LENGTH = MIN_NEW_PASSWORD_LENGTH

  protected password = input<string | null>(null)

  readonly passwordLengthIndicator = computed(() =>
    this.accountService.getPasswordLengthIndicator(this.password() || ''),
  )
}
